import CUZKDataService from '@/services/CUZKDataService';
import { xmlToObject } from '@/utils/helpers.js';
import AreasService from '@/services/AreasService';
import PhasesService from '@/services/PhasesService';
import ButtonsService from '@/services/ButtonsService';
import {
  groupBy,
  createPolyline,
  destroyPolyline,
  clonePolyline
} from '@/utils/helpers.js';
import WizardService from '@/services/WizardService';
import { isMobile } from 'mobile-device-detect';
import router from '@/router';

const groupByPhaseId = groupBy('phaseId');

export const namespaced = true;

const attachPolylineEventHandlers = (polyline, gmaps, commit) => {
  polyline.addPoint = (event) => {
    commit('PIN_ADD_POINT_TO_LINE', { gmaps, commit, latLng: event.latLng });
  };

  polyline.removePoint = (event) => {
    if (event.vertex !== 0) {
      commit('PIN_REMOVE_POINT_FROM_LINE', {
        gmaps,
        commit,
        index: event.vertex
      });
    }
  };

  polyline.updateLine = (event) => {
    commit('PIN_UPDATE_LINE', { gmaps, commit });
  };

  polyline.addPointListener = gmaps.map.addListener('click', polyline.addPoint);

  polyline.removePointListener = polyline.addListener(
    'rightclick',
    polyline.removePoint
  );

  polyline.updateLineListener = polyline.addListener(
    'mouseup',
    polyline.updateLine
  );
};

export const state = {
  accessToken: null,
  enableGeolocation: false,
  areas: [],
  phases: [],
  buttons: [],
  isMobile,
  areaId: null,
  phaseId: 0,
  controlsRight: 'comments',
  controlsLeft: 'caption',
  comment: {
    marker: null,
    lat: null,
    lng: null,
    phase: 0
  },
  editPinId: null,
  pin: {
    marker: null,
    polyline: {
      polyline: null,
      position: null
    },
    lat: null,
    lng: null,
    phase: 0,
    layerId: null,
    permissions: {
      canPublish: false,
      canComment: false,
      canRate: false
    },
    lines: {},
    activeLine: null,
    prevLines: null
  },
  replyToComment: null,
  //leftColOpen: false,
  //rightColOpen: true,
  singleCommentOpen: false,
  userId: null,
  user: {
    permissions: {
      canAddComments: false
    }
  },
  infowindow: null,
  layout: {
    sidebarGeneral: true,
    sidebarLeft: true,
    sidebarRight: true,
    phasesTimeline: false,
    layers: false,
    layersShowAll: false,
    newComment: false,
    newPin: false,
    editPin: false,
    threadDetail: false
  },
  mapButtonSelectedLayerId: null,
  drawingManager: null,
  openedThreadDetailId: null,
  modalOpen: false,
  openedLayeredPinDetailId: 0,
  showCadastralLayer: false,
  buildingBBoxPath: null,
  cadastralBboxPath: null,
  modalOnlyFlag: false, // Used to determine if the sidebar was opened only to show the modal (To close the sidebar when user closes modal)
  wizard: null
};
export const mutations = {
  SET_MAP_BUTTON_LAYER_ID(state, mapButtonSelectedLayerId) {
    state.mapButtonSelectedLayerId = mapButtonSelectedLayerId;
  },
  SET_ACCESS_TOKEN(state, accessToken) {
    state.accessToken = accessToken;
  },

  SET_ENABLE_GEOLOCATION(state, newState) {
    state.enableGeolocation = newState;
  },
  SET_PHASE(state, phaseId) {
    state.phaseId = phaseId;
  },
  SET_EDIT_PIN_ID(state, id) {
    state.editPinId = id;
  },
  DESTROY_EDIT_PIN_ID(state) {
    state.editPinId = null;
  },
  SET_AREA_ID(state, areaId) {
    state.areaId = areaId;
  },
  SET_AREAS(state, areas) {
    state.areas = areas;
  },
  SET_PHASES(state, phases) {
    state.phases = phases;
  },
  SET_BUTTONS(state, buttons) {
    state.buttons = buttons;
  },
  SET_USER_ID(state, id) {
    state.userId = id;
  },
  SET_USER(state, user) {
    state.user = user;
  },

  SET_BUILDING_BBOX_PATH(state, newState) {
    state.buildingBBoxPath = newState;
  },

  DESTROY_BUILDING_BBOX_PATH(state, newState) {
    state.buildingBBoxPath.setMap(null);
    state.buildingBBoxPath = null;
  },

  SET_CADASTRAL_BBOX_PATH(state, newState) {
    state.cadastralBBoxPath = newState;
  },

  DESTROY_CADASTRAL_BBOX_PATH(state, newState) {
    state.cadastralBBoxPath.setMap(null);
    state.cadastralBboxPath = null;
  },

  SET_NEW_COMMENT_PHASE(state, newPhase) {
    state.comment.phase = newPhase;
  },

  STORE_MARKER(state, marker) {
    state.comment.marker = marker;
  },

  STORE_COMMENT_POSITION(state, [lat, lng]) {
    state.comment.lat = lat;
    state.comment.lng = lng;
  },

  STORE_PIN_POSITION(state, [lat, lng]) {
    state.pin.lat = lat;
    state.pin.lng = lng;
  },

  STORE_POLYLINE_POSITION(state, position) {
    state.pin.polyline.position = position;
  },

  SET_NEW_PIN_PHASE(state, newPhase) {
    state.pin.phase = newPhase;
  },

  SET_NEW_PIN_LAYER_ID(state, value) {
    state.pin.layerId = value;
  },

  STORE_PIN_MARKER(state, marker) {
    state.pin.marker = marker;
  },

  STORE_PIN_POLYLINE(state, polyline) {
    state.pin.polyline.polyline = polyline;
  },

  DESTROY_PIN_MARKER(state) {
    state.pin.marker.setMap(null);
    state.pin.marker = null;
    state.pin.lat = null;
    state.pin.lng = null;
  },

  DESTROY_MARKER(state) {
    state.comment.marker.setMap(null);
    state.comment.marker = null;
    state.comment.lat = null;
    state.comment.lng = null;
  },

  SET_REPLY_TO_COMMENT(state, threadId) {
    state.replyToComment = threadId;
  },

  SET_LEFT_COL_STATUS(state, status) {
    state.leftColOpen = status;
  },

  SET_RIGHT_COL_STATUS(state, status) {
    state.rightColOpen = status;
  },

  // @TODO: check if possible to remove
  SET_SINGLE_COMMENT_STATUS(state, status) {
    state.singleCommentOpen = status;
  },

  SET_INFOWINDOW(state, infowindowGmapsObj) {
    state.infowindow = infowindowGmapsObj;
  },

  SET_INFOWINDOW_CONTENT_AND_OPEN(state, [content, map, marker]) {
    state.infowindow.setContent(content);
    state.infowindow.open(map, marker);
  },

  SET_LAYOUT_OPTION(state, [layoutPart, value]) {
    state.layout[layoutPart] = value;
  },

  SET_OPENED_THREAD_DETAIL_ID(state, threadId) {
    state.openedThreadDetailId = threadId;
  },

  SET_SHOW_ALL_LAYERS(state, status) {
    state.layout.layersShowAll = status;
  },

  SET_OPENED_LAYERED_PIN_ID(state, layeredPinId) {
    state.openedLayeredPinDetailId = layeredPinId;
  },

  SET_MODAL_OPEN_STATUS(state, status) {
    state.modalOpen = status;
  },

  SET_SHOW_CADASTRAL_LAYER(state, status) {
    if (status == true) {
      state.showCadastralLayer = false;
    } else {
      state.showCadastralLayer = true;
    }
  },

  SET_MODAL_ONLY_FLAG(state, flagStatus) {
    state.modalOnlyFlag = flagStatus;
  },

  PIN_DRAW_LINE(state, { line }) {
    state.pin.activeLine = line;
    state.pin.activeLine.setEditable(true);
    state.pin.activeLine.setDraggable(true);
  },

  PIN_ADD_POINT_TO_LINE(state, { latLng }) {
    const path = state.pin.activeLine.getPath();
    path.push(latLng);
  },

  PIN_REMOVE_POINT_FROM_LINE(state, { index }) {
    const path = state.pin.activeLine.getPath();
    path.removeAt(index);
  },

  PIN_UPDATE_LINE(state, { gmaps, commit }) {
    const polyline = clonePolyline(gmaps, state.pin.activeLine);
    attachPolylineEventHandlers(polyline, gmaps, commit);
    destroyPolyline(state.pin.activeLine);
    state.pin.activeLine = polyline;
  },

  PIN_ADD_LINE(state, { gmaps }) {
    const polyline = clonePolyline(gmaps, state.pin.activeLine);
    polyline.setEditable(false);
    polyline.setDraggable(false);

    destroyPolyline(state.pin.activeLine);

    state.pin.lines = {
      ...state.pin.lines,
      [polyline.id]: polyline
    };
  },

  PIN_DELETE_LINE(state, { id }) {
    state.pin.lines[id] = null;
    state.pin.lines = Object.keys(state.pin.lines).reduce((acc, key) => {
      const line = state.pin.lines[key];
      if (line) {
        acc[key] = line;
      }
      return acc;
    }, {});
  },

  CLEAR_ACTIVE_LINE(state) {
    if (state.pin.activeLine) {
      state.pin.activeLine = destroyPolyline(state.pin.activeLine);
    }
  },

  CLEAR_LINES(state) {
    Object.keys(state.pin.lines).forEach((key) => {
      destroyPolyline(state.pin.lines[key]);
    });

    state.pin.lines = {};
  },

  SET_LINES(state, { lines }) {
    state.pin.lines = lines;
  },

  SET_PREV_LINES(state, { lines }) {
    state.pin.prevLines = lines;
  },

  RESTORE_PREV_LINES(state, { gmaps }) {
    if (state.pin.prevLines) {
      state.pin.prevLines.forEach((line) => {
        const polyline = clonePolyline(gmaps, line);
        polyline.setMap(gmaps.map);
        state.pin.lines[polyline.id] = polyline;
        destroyPolyline(line);
      });
    }
    state.pin.prevLines = null;
  },

  CLEAR_PREV_LINES(state) {
    if (state.pin.prevLines) {
      state.pin.prevLines = null;
    }
  },

  SET_WIZARD(state, wizard) {
    state.wizard = wizard;
  }
};

export const actions = {
  setMapButtonSelectedLayerId({ commit }, id) {
    commit('SET_MAP_BUTTON_LAYER_ID', id);
  },
  setAccessToken({ commit }, accessToken) {
    commit('SET_ACCESS_TOKEN', accessToken);
  },
  setEnableGeolocation({ commit }, state) {
    commit('SET_ENABLE_GEOLOCATION', state);
  },
  setAreaId({ commit }, areaId) {
    commit('SET_AREA_ID', areaId);
  },
  setUserId({ commit }, id) {
    commit('SET_USER_ID', id);
  },
  setUser({ commit }, user) {
    commit('SET_USER', user);
  },
  setPhase({ commit, state }, phaseId) {
    const currentPhase = state.phaseId;
    commit('SET_PHASE', phaseId);

    if (currentPhase === phaseId) {
      return;
    }

    const phase = state.phases[state.phaseId];
    const wizardId = (phase && phase.wizard_id) || 1;

    if (wizardId) {
      WizardService.get(wizardId)
        .then((wizard) => {
          if (wizard.data && wizard.data.data)
            commit('SET_WIZARD', wizard.data.data);
        })
        .catch((err) => {
          // noop
        });
    }
  },

  loadAreas({ commit }) {
    AreasService.getAll()
      .then((areas) => {
        commit('SET_AREAS', areas.data);
      })
      .catch(() => {
        // noop, or logging
      });
  },

  loadPhases({ commit }) {
    PhasesService.getAllPhases()
      .then((phases) => {
        commit('SET_PHASES', phases.data);
      })
      .catch(() => {
        // noop, or logging
      });
  },

  loadButtons({ commit }) {
    ButtonsService.getAll()
      .then((buttons) => {
        commit('SET_BUTTONS', buttons.data);
      })
      .catch(() => {
        // noop, or logging
      });
  },
  setEditPinId({ commit }, value) {
    commit('SET_EDIT_PIN_ID', value);
  },
  clearEditPinId({ commit }) {
    commit('DESTROY_EDIT_PIN_ID');
  },
  setNewPinLayerId({ commit }, value) {
    commit('SET_NEW_PIN_LAYER_ID', value);
  },

  mapClicked({ commit, rootState, state }, event) {
    const { Marker, Polyline, drawing } = rootState.gmaps.google.maps;

    if (state.showCadastralLayer) {
      let lat = event.latLng.lat();
      let lng = event.latLng.lng();
      const newWindow = window.open(
        'about:blank',
        '_blank',
        'width=600,height=700,toolbar=0,location=0,menubar=0'
      );

      CUZKDataService.getBuildingInfo(lat, lng).then((response) => {
        xmlToObject(response.data).then((response) => {
          if (response['FeatureCollection']) {
            return; // is null do nothing
          }

          let bounds =
            response['bu-ext2d:Building']['bu-core2d:geometry2D'][0][
              'bu-base:BuildingGeometry2D'
            ][0]['bu-base:geometry'][0]['gml:Polygon'][0]['gml:exterior'][0][
              'gml:LinearRing'
            ][0]['gml:posList'][0];

          let bbox = bounds.match(/(.*?\s){2}/g);
          let coordinates = bbox.map((coordinates) => {
            let trimed = coordinates.slice(0, -1);

            let coords = trimed.split(' ');

            return { lat: parseFloat(coords[0]), lng: parseFloat(coords[1]) };
          });

          commit(
            'SET_BUILDING_BBOX_PATH',
            new Polyline({
              path: coordinates,
              strokeColor: '#FF0000',
              strokeOpacity: 1.0,
              strokeWeight: 3
            })
          );

          state.buildingBBoxPath.setMap(rootState.gmaps.map);
        });
      });

      CUZKDataService.getCadastralParcelInfo(lat, lng).then((response) => {
        xmlToObject(response.data).then((response) => {
          if (response['FeatureCollection']) {
            return;
          }

          let id =
            response['cp:CadastralParcel']['cp:inspireId'][0][
              'base:Identifier'
            ][0]['base:localId'][0];

          let bounds =
            response['cp:CadastralParcel']['cp:geometry'][0]['gml:Polygon'][0][
              'gml:exterior'
            ][0]['gml:LinearRing'][0]['gml:posList'][0];

          let bbox = bounds.match(/(.*?\s){2}/g);
          let coordinates = bbox.map((coordinates) => {
            let trimed = coordinates.slice(0, -1);

            let coords = trimed.split(' ');

            return { lat: parseFloat(coords[0]), lng: parseFloat(coords[1]) };
          });

          commit(
            'SET_CADASTRAL_BBOX_PATH',
            new Polyline({
              path: coordinates,
              strokeColor: '#4cff38',
              strokeOpacity: 1.0,
              strokeWeight: 3
            })
          );

          state.cadastralBBoxPath.setMap(rootState.gmaps.map);

          const url = CUZKDataService.getParcelModalUrl(
            id.replace(/[^0-9]/g, '')
          );

          newWindow.location = url;
        });
      });
    }

    if (
      state.comment.phase &&
      !state.comment.marker &&
      state.layout.newComment
    ) {
      // Add Marker + Save position
      const marker = new Marker({
        position: {
          lat: event.latLng.lat(),
          lng: event.latLng.lng()
        },
        optimized: false,
        map: rootState.gmaps.map,
        draggable: true,
        title:
          'Aktuální poloha Vašeho komentáře. Přetažením tohoto pinu ji můžete upravit.'
      });

      commit('STORE_COMMENT_POSITION', [
        event.latLng.lat(),
        event.latLng.lng()
      ]);
      commit('SET_NEW_COMMENT_PHASE', 2);

      marker.addListener('dragend', () => {
        // Store updated position
        commit('STORE_COMMENT_POSITION', [
          marker.getPosition().lat(),
          marker.getPosition().lng()
        ]);
      });

      // Store marker
      commit('STORE_MARKER', marker);
    }

    if (state.pin.phase && state.layout.newPin && !state.pin.marker) {
      // Add Marker + Save position
      const marker = new Marker({
        position: {
          lat: event.latLng.lat(),
          lng: event.latLng.lng()
        },
        optimized: false,
        map: rootState.gmaps.map,
        draggable: true,
        title: 'Aktuální poloha Vašeho pinu.'
      });
      commit('STORE_PIN_POSITION', [event.latLng.lat(), event.latLng.lng()]);
      commit('SET_NEW_PIN_PHASE', 2);

      marker.addListener('dragend', () => {
        // Store updated position
        commit('STORE_PIN_POSITION', [
          marker.getPosition().lat(),
          marker.getPosition().lng()
        ]);
      });

      // Store marker
      commit('STORE_PIN_MARKER', marker);
    }
  },

  setDrawingLines({ commit, rootState }, { lines }) {
    const polylines = lines.reduce((acc, line) => {
      const polyline = clonePolyline(rootState.gmaps, line);
      acc[polyline.id] = polyline;
      return acc;
    }, {});

    commit('SET_LINES', { lines: polylines });

    lines.forEach((line) => {
      line.setMap(null);
    });

    commit('SET_PREV_LINES', { lines });
  },

  clearPreviousLines({ commit }) {
    commit('CLEAR_LINES');
    commit('CLEAR_ACTIVE_LINE');
    commit('CLEAR_PREV_LINES');
  },

  restorePreviousLines({ commit, rootState }) {
    commit('CLEAR_LINES');
    commit('CLEAR_ACTIVE_LINE');
    commit('RESTORE_PREV_LINES', { gmaps: rootState.gmaps });
    commit('CLEAR_PREV_LINES');
  },

  startDrawingLine({ commit, rootState, state }, { id } = {}) {
    let polyline;
    if (id) {
      polyline = state.pin.lines[id];
      if (!polyline) {
        return;
      }
    } else {
      polyline = createPolyline(rootState.gmaps);
    }

    attachPolylineEventHandlers(polyline, rootState.gmaps, commit);

    commit('PIN_DRAW_LINE', { line: polyline });
  },

  finishDrawingLine({ commit, rootState, state }) {
    commit('PIN_ADD_LINE', { gmaps: rootState.gmaps });
    commit('CLEAR_ACTIVE_LINE');
  },

  cancelDrawingLine({ commit, rootState, state }) {
    commit('CLEAR_ACTIVE_LINE');
  },

  deleteLine({ commit, rootState, state }, { id } = {}) {
    const activeLine = state.pin.activeLine;
    const polyline = state.pin.lines[id];
    if (!activeLine && polyline) {
      polyline.setMap(null);
      commit('PIN_DELETE_LINE', { id });
    }
  },

  setNewCommentPhase({ commit, state }, phaseNum) {
    commit('SET_NEW_COMMENT_PHASE', phaseNum);
    if (phaseNum === null && state.comment.marker != null) {
      commit('DESTROY_MARKER');
    }
  },

  setNewPinPhase({ commit, state, rootState }, phaseNum) {
    commit('SET_NEW_PIN_PHASE', phaseNum);
    if (phaseNum === null && state.pin.marker != null) {
      commit('DESTROY_PIN_MARKER');
      commit('CLEAR_ACTIVE_LINE');
      commit('CLEAR_LINES');
    }
  },
  setCommentReply({ commit }, threadId) {
    commit('SET_REPLY_TO_COMMENT', threadId);
  },

  // col = 'l' / 'r' (~left/right)
  toggleCol({ commit, state }, col) {
    if (col == 'l') {
      if (state.leftColOpen === true) {
        commit('SET_LEFT_COL_STATUS', false);
      } else {
        commit('SET_LEFT_COL_STATUS', true);
      }
    } else {
      if (state.rightColOpen === true) {
        commit('SET_RIGHT_COL_STATUS', false);
      } else {
        commit('SET_RIGHT_COL_STATUS', true);
      }
    }
  },

  setColStatus({ commit }, [col, status]) {
    if (col == 'l') {
      commit('SET_LEFT_COL_STATUS', status);
    } else {
      commit('SET_RIGHT_COL_STATUS', status);
    }
  },

  setSingleCommentStatus({ commit }, status) {
    commit('SET_SINGLE_COMMENT_STATUS', status);
  },

  // ====== Infowindow ======
  setInfowindow({ commit, state }, infowindowGmapsObj) {
    commit('SET_INFOWINDOW', infowindowGmapsObj);
  },

  setContentAndOpenInfowindow({ commit, rootState }, [content, marker]) {
    let map = rootState.gmaps.google.maps;
    commit('SET_INFOWINDOW_CONTENT_AND_OPEN', [content, map, marker]);
  },

  removeBuildingPolyline({ commit, rootState }) {},

  // ====== Layout options ======
  setLayoutOption({ commit, rootState }, [layoutPart, value]) {
    commit('SET_LAYOUT_OPTION', [layoutPart, value]);

    let parameters = {
      ...rootState.route.params
    };
    parameters[layoutPart] = value;

    router
      .replace({
        name: 'base',
        params: parameters,
        query: rootState.route.query
      })
      .catch((err) => {
        // noop
      });
  },

  /**
   * Sets open texts (<details>) to URL
   * @param {string} texts  Stringified array of IDs;  e.g.: `[1, 2]`
   */
  setOpenTexts({ rootState }, texts) {
    let obj = {
      ...rootState.route.params
    };

    obj.openTexts = texts;

    router.replace({ name: 'base', params: obj }).catch((err) => {
      // noop
    });
  },

  /**
   * Sets open settings (captions) (<details>) to URL
   * @param {string} settings  Stringified array of IDs;  e.g.: `[1, 2]`
   */
  setOpenSettings({ rootState }, settings) {
    let obj = {
      ...rootState.route.params
    };

    obj.openSettings = settings;

    router.replace({ name: 'base', params: obj }).catch((err) => {
      // noop
    });
  },

  /**
   * Sets open pin's <details> to URL
   * @param {string} pins  Stringified array of IDs;  e.g.: `[1, 2]`
   */
  setOpenPins({ rootState }, pins) {
    let obj = {
      ...rootState.route.params
    };

    obj.openPins = pins;

    router.replace({ name: 'base', params: obj }).catch((err) => {
      // noop
    });
  },

  toggleShowAllLayersStatus({ commit }) {
    if (state.layout.layersShowAll == true) {
      commit('SET_SHOW_ALL_LAYERS', false);
    } else {
      commit('SET_SHOW_ALL_LAYERS', true);
    }
  },

  setOpenedThreadDetailId({ commit }, threadId) {
    commit('SET_OPENED_THREAD_DETAIL_ID', threadId);
  },

  setOpenedLayeredPinDetailId({ commit }, layeredPinId) {
    commit('SET_OPENED_LAYERED_PIN_ID', layeredPinId);
  },

  setModalOpenStatus({ commit }, status) {
    commit('SET_MODAL_OPEN_STATUS', status);
  },

  setShowCadastralLayer({ commit }, status) {
    commit('SET_SHOW_CADASTRAL_LAYER', status);
  },

  setModalOnlyFlag({ commit }, flagStatus) {
    commit('SET_MODAL_ONLY_FLAG', flagStatus);
  },

  destroyBBoxPaths({ commit, state }) {
    if (state.cadastralBBoxPath) {
      commit('DESTROY_CADASTRAL_BBOX_PATH');
    }
    if (state.buildingBBoxPath) {
      commit('DESTROY_BUILDING_BBOX_PATH');
    }
  },

  destroyPinPolyline({ commit }) {
    commit('CLEAR_ACTIVE_LINE');
    commit('CLEAR_LINES');
  },

  getWizard({ commit }) {
    let wId;
    const { openOnLoad, wizardId } = WizardService.getWizardState();

    console.log('wizardId', wizardId);

    if (openOnLoad && wizardId) {
      wId = wizardId;
    } else {
      const el = document.querySelector('[data-wizard-id]');
      if (el) {
        wId = el.dataset.wizardId;
      }
    }

    if (wId) {
      WizardService.get(wId)
        .then((wizard) => {
          commit('SET_WIZARD', wizard);
        })
        .catch(() => {
          // noop
        });
    }
  },

  setWizard({ commit }, wizard) {
    commit('SET_WIZARD', wizard);
  }
};

export const getters = {
  buttonsAboveText: (state) => {
    const data = state.buttons['aboveTexts'];
    if (!data) {
      return [];
    }

    const buttons = groupByPhaseId(data)[state.phaseId];

    if (!buttons) {
      return [];
    }

    return buttons.filter((button) => {
      return button.areaId === state.areaId;
    });
  },
  buttonsAboveCaption: (state) => {
    const data = state.buttons['aboveCaption'];

    if (!data) {
      return [];
    }

    const buttons = groupByPhaseId(data)[state.phaseId];

    if (!buttons) {
      return [];
    }

    return buttons.filter((button) => {
      return button.areaId === state.areaId;
    });
  },
  buttonsLayer: (state) => {
    return state.buttons['layer'];
  },
  accessToken: (state) => {
    return state.accessToken;
  },
  currentArea: (state) => {
    if (!state.areaId) {
      return;
    }

    return state.areas.find((item) => {
      return item.id === state.areaId;
    });
  }
};
